import React, { useState } from 'react';
import { Info } from 'lucide-react';

/**
 * Reusable Tooltip Component
 * Provides hover-based tooltips with info icon
 */
export const Tooltip = ({ children, content, position = 'top', showIcon = true }) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <div className="relative inline-flex items-center gap-1">
      {children}
      {showIcon && (
        <div
          className="inline-flex cursor-help"
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
        >
          <Info className="w-4 h-4 text-gray-400 hover:text-blue-500 transition-colors" />
        </div>
      )}
      {isVisible && (
        <div
          className={`absolute z-50 ${positionClasses[position]} w-64 px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg`}
          style={{ pointerEvents: 'none' }}
        >
          <div className="relative">
            {content}
            {/* Arrow */}
            <div
              className={`absolute w-2 h-2 bg-gray-900 transform rotate-45 ${
                position === 'top'
                  ? 'bottom-[-4px] left-1/2 -translate-x-1/2'
                  : position === 'bottom'
                  ? 'top-[-4px] left-1/2 -translate-x-1/2'
                  : position === 'left'
                  ? 'right-[-4px] top-1/2 -translate-y-1/2'
                  : 'left-[-4px] top-1/2 -translate-y-1/2'
              }`}
            />
          </div>
        </div>
      )}
    </div>
  );
};

/**
 * Simple inline tooltip without icon
 * Uses native browser tooltip for simple cases
 */
export const SimpleTooltip = ({ children, content }) => {
  return (
    <span title={content} className="cursor-help">
      {children}
    </span>
  );
};

export default Tooltip;
